import {Button, Tag, Tooltip} from "antd";
import UserRowMenu from "./UserRowMenu";
import UserPresenceCell from "./UserPresenceCell";

export default function userColumns(t, onSelect)
{
    let columns = [
        {
            title: t('Id'),
            dataIndex: 'id',
            key: 'id',
            width: 70,
            render: (text, record) => {
                return (
                    <UserRowMenu
                        row={record}
                    />
                );
            }
        },
        {
            // Çevrimiçi bilgisi uygulama loglarından türer, DB'de tutulmaz — bu yüzden sıralanamaz.
            title: t('Online'),
            dataIndex: 'presence',
            key: 'presence',
            width: 150,
            render: (presence) => <UserPresenceCell presence={presence}/>
        },
        {
            title: t('Name'),
            dataIndex: 'name',
            key: 'name',
            sorter: true,
            ellipsis: true,
        },
        {
            title: t('Visible Name'),
            dataIndex: 'visibleName',
            key: 'visibleName',
            sorter: true,
            ellipsis: true,
        },
        {
            title: t('Username'),
            dataIndex: 'username',
            key: 'username',
            sorter: true,
            ellipsis: true,
        },
        {
            title: t('Email'),
            dataIndex: 'email',
            key: 'email',
            sorter: true,
            ellipsis: true,
            render: (text) => text
                ? <Tooltip title={text}><a href={`mailto:${text}`}>{text}</a></Tooltip>
                : '-',
        },
        {
            title: t('Phone'),
            dataIndex: 'phone',
            key: 'phone',
            sorter: true,
            width: 140,
            render: (text) => text || '-',
        },
        {
            title: t('Role'),
            dataIndex: 'role',
            key: 'role',
            columnName: 'role.name',
            sorter: true,
            width: 160,
            render: (text, record) => record.role ? <Tag>{record.role.name}</Tag> : '-',
        },
        {
            title: t('Active/Inactive'),
            dataIndex: 'enabled',
            key: 'enabled',
            sorter: true,
            width: 120,
            render: (enabled) => (
                <Tag color={enabled ? 'green' : 'red'}>
                    {enabled ? t('Active') : t('Inactive')}
                </Tag>
            )
        },
    ];

    if(onSelect)
    {
        columns = [
            {
                title: t('Select'),
                key: 'select',
                width: 100,
                render: (text, record) => {
                    return (
                        <>
                            <Button onClick={() => {onSelect(record)}}>
                                {t('Select')}
                            </Button>
                        </>
                    )
                }
            },
            ...columns
        ]
    }

    return columns;
}
